import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { Button, Cell, Checkbox, Icon, Modal, Spacer, Text } from '@vinted/web-ui';
import List from 'components/List';
import { ROOT_URL } from 'constants/routes';
import { generateRandomUser } from 'data/api/account';
import { navigateToPage } from 'libs/utils/window';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

class RandomUserSignup extends Component {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    _defineProperty(this, "state", {
      error: false,
      isLoading: false,
      isSettingsModalOpen: false,
      isGod: true
    });

    _defineProperty(this, "setError", function () {
      let error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({
        error
      });
    });

    _defineProperty(this, "setIsLoading", function () {
      let isLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      _this.setState({
        isLoading
      });
    });

    _defineProperty(this, "toggleModal", () => {
      this.setState(prevState => ({
        isSettingsModalOpen: !prevState.isSettingsModalOpen
      }));
    });

    _defineProperty(this, "generateUser", async () => {
      const {
        isLoading,
        isGod
      } = this.state;
      if (isLoading) return;
      this.setError();
      this.setIsLoading();

      try {
        await generateRandomUser({
          isGod
        });
        navigateToPage(ROOT_URL);
      } catch (exception) {
        this.setError(true);
      } finally {
        this.setIsLoading(false);
      }
    });

    _defineProperty(this, "toggleIsGod", () => {
      this.setState(prevState => ({
        isGod: !prevState.isGod
      }));
    });

    _defineProperty(this, "renderModal", () => {
      const {
        isSettingsModalOpen,
        isLoading,
        isGod
      } = this.state;
      return /*#__PURE__*/_jsx(Modal, {
        show: isSettingsModalOpen,
        children: /*#__PURE__*/_jsxs(List, {
          children: [/*#__PURE__*/_jsx(Cell, {
            styling: Cell.Styling.Wide,
            children: /*#__PURE__*/_jsx(Text, {
              type: Text.Type.Title,
              alignment: Text.Alignment.Center,
              width: Text.Width.Parent,
              text: "Generate user settings"
            })
          }), /*#__PURE__*/_jsx(Cell, {
            styling: Cell.Styling.Wide,
            title: "Assign god role?",
            suffix: /*#__PURE__*/_jsx(Checkbox, {
              name: "is_god",
              checked: isGod,
              onClick: this.toggleIsGod
            })
          }), /*#__PURE__*/_jsx(Cell, {
            styling: Cell.Styling.Wide,
            children: /*#__PURE__*/_jsx(Button, {
              text: "Save",
              styling: Button.Styling.Filled,
              isLoading: isLoading,
              onClick: this.toggleModal
            })
          })]
        })
      });
    });
  }

  render() {
    const {
      isLoading,
      error
    } = this.state;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [error && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          theme: "warning",
          type: Text.Type.Subtitle,
          alignment: Text.Alignment.Center,
          width: Text.Width.Parent,
          text: "Server error"
        }), /*#__PURE__*/_jsx(Spacer, {})]
      }), /*#__PURE__*/_jsxs("div", {
        className: "u-flexbox",
        children: [/*#__PURE__*/_jsx(Button, {
          text: "Generate random user",
          isLoading: isLoading,
          onClick: this.generateUser
        }), /*#__PURE__*/_jsx(Spacer, {
          orientation: Spacer.Orientation.Vertical
        }), /*#__PURE__*/_jsx(Button, {
          icon: /*#__PURE__*/_jsx(Icon, {
            name: "settings",
            color: Icon.Color.Calypso
          }),
          inline: true,
          onClick: this.toggleModal
        })]
      }), this.renderModal()]
    });
  }

}

export default RandomUserSignup;